import { BrowserModule } from '@angular/platform-browser';
import { NgModule, enableProdMode } from '@angular/core';
import { HttpClientModule } from '@angular/common/http'
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { FormsModule } from '@angular/forms';
import { ServiceWorkerModule } from '@angular/service-worker'
import { environment } from '../environments/environment'
import { Constants } from './global-data/constants'
import {NgxPaginationModule} from 'ngx-pagination';
import { ProductQrCodeComponent } from './product-qr-code/product-qr-code.component';
import { CommonModule } from '@angular/common';
import { SharedModalComponent } from './shared-modal/shared-modal.component';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { MatDialogModule } from '@angular/material/dialog';
import { CookieSettingsModule } from './common-modules/cookie-settings/cookie-settings.module';
import { AutoCloseDialogComponent } from './common-modules/dialog/auto-close-dialog/auto-close-dialog.component';
// import { SafePipe } from './@services/safe.pipe';
// import { LandingPageComponent } from './landing-page/landing-page.component';
const config: SocketIoConfig = {
	url: window.location.href.indexOf('https://qudify.co/')>=0 ? 'https://api.qudify.co/':'https://api.stage.qudify.co/' , // socket server url;
	options: {
     autoConnect: false,
		transports: ['websocket'],
    // auth: {
    //   token: JSON.parse(localStorage.getItem('auth.token'))?.val
    // },
    query: {
      token: JSON.parse(localStorage.getItem('auth.token'))?.val
    }
    // extraHeaders: {
    //   Authorization: `Bearer ewjfwkefwkefjnwekj`
    // }
	} as any
}

@NgModule({
  declarations: [
    AppComponent,
    ProductQrCodeComponent,
    SharedModalComponent,
    AutoCloseDialogComponent,
    // SafePipe,
    // LandingPageComponent    
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgxPaginationModule,
    FormsModule,
    SocketIoModule.forRoot(config), 
    MatDialogModule,
    CookieSettingsModule
    // ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
if (environment.production) {
  enableProdMode();

  if (window.location.href.indexOf('https://qudify.co/') > -1) {
    console.log('© Powered by Qdesq Realtech Pvt. Ltd.');

    Constants.apiPath = 'https://api.qudify.co/';
    Constants.apiPathLive = 'https://api.qdesq.com';
    Constants.razorpayKey = 'rzp_live_mni7cesLf1G9By';
  } else {
    console.log('meta');
  }

  if (
    'serviceWorker' in navigator &&
    navigator.serviceWorker &&
    typeof navigator.serviceWorker.getRegistrations === 'function'
  ) {
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => {
        console.log('registration-----', registrations);

        if (registrations && registrations.length > 0) {
          registrations.forEach((registration) => {
            registration.unregister();
          });

          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      })
      .catch((error) => {
        console.warn('Unable to access service worker registrations:', error);
      });
  }
}
